import moment from 'moment';

/**
 * Client-side mirror of the backend rolling "auto-close next month" rule.
 * Used as a fallback so the calendar disables closed months even before the
 * server-provided monthsStatus flags load. The backend remains authoritative.
 *
 * The cutoff day is the last day the next month can still be booked.
 *
 * @param {Object} eventType - Must contain autoCloseNextMonth { enabled, cutoffDay }.
 * @param {moment.Moment|Date|string} targetDate
 * @param {moment.Moment} [now]
 * @returns {boolean}
 */
export function isMonthClosedByRollingCutoff(eventType, targetDate, now = moment()) {
  const cfg = eventType?.autoCloseNextMonth;
  if (!cfg || cfg.enabled !== true) return false;

  const cutoffDay = Number.isInteger(cfg.cutoffDay) && cfg.cutoffDay >= 1 && cfg.cutoffDay <= 28
    ? cfg.cutoffDay
    : 15;

  const nowM = moment(now);
  const targetM = moment(targetDate);
  const nextMonth = nowM.clone().startOf('month').add(1, 'month');

  const isTargetNextMonth =
    targetM.year() === nextMonth.year() && targetM.month() === nextMonth.month();

  if (!isTargetNextMonth) return false;

  return nowM.date() > cutoffDay;
}

export default isMonthClosedByRollingCutoff;
